const answerStrings = {
    2: {
        strings: [
            'Urban', 'Rural'
        ]
    },
    3: {
        strings: [
            'Yes', 'No'
        ]
    },
    4: {
        strings: [
            'Yes', 'No'
        ]
    },
    5: {
        strings: [
            'Yes', 'No', 'Missing answer'
        ]
    },
    6: {
        strings: [
            'lower', 'middle', 'upper', 'prefer', 'Missing answer'
        ]
    },
    7: {
        strings: [
            'male', 'woman', 'binary', 'prefer'
        ]
    },
    8: {
        strings: [
            "children's", 
            "civil and political",
            "corruption",
            "privacy",
            "disability",
            "economic",
            "elections",
            "environmental",
            "girls",
            "impunity",
            "indigenous",
            "lgbti",
            "migrants",
            "journalist",
            "defence",
            "other"
        ]
    },
    9: {
        strings: [
            "no,",
            "secure access, but",
            "some",
            "yes,",
            "i do not know"
        ]
    },
    10: {
        strings: [
            "no, complaints brought",
            "only some complaints",
            "most complaints",
            "yes, complaints",
            "i do not know"
        ]
    },
    11: {
        strings: [
            "no, HRDs do not",
            "some extent",
            "HRDs benefit to a large extent from a remedy and reparation",
            "HRDs benefit from an effective remedy and full reparation",
            "I do not know",
            "Missing answer"
        ]
    },
    12: {
        strings: [
            "Yes, human rights organisations",
            "face severe",
            "face some",
            "No, human rights organisations do not",
            "I do not know"
        ]
    },
    13: {
        strings: [
            "are completely",
            "to a large extent",
            "to some extent",
            "do not face",
            "I do not know"
        ]
    },
    14: {
        strings: [
            "always",
            "often",
            "sometimes",
            "never",
            "I do not know"
        ]
    },
    15: {
        strings: [
            "always",
            "often",
            "sometimes",
            "do not need",
            "I do not know"
        ]
    },
    16: {
        strings: [
            "are unable",
            "severe",
            "some",
            "can operate",
            "I do not know"
        ]
    },
    17: {
        strings: [
            "different backgrounds do not enjoy equal treatment",
            "almost all grounds",
            "some extent treated equally with distinctions being made on numerous grounds",
            "treated equally to some extent",
            "large extent",
            "without distinction",
            "I do not know"
        ]
    },
    18: {
        strings: [
            "are not able",
            "hardly any",
            "some extent",
            "large extent",
            "are able to freely express",
            "freedom of expression is protected"
        ]
    },
    19: {
        strings: [
            "fully limit",
            "often used to limit",
            "sometimes used to limit",
            "not used to limit",
            "I do not know",
            "Missing answer"
        ]
    },
    20: {
        strings: [
            "fully limit",
            "large extent",
            "some extent",
            "not used to limit",
            "I do not know"
        ]
    },

    21: {
        strings: [
            "not respected",
            "weakly respected",
            "some extent",
            "by public authorities to a certain",
            "large extent",
            "fully respected",
            "I do not know"
        ]
    },
    22: {
        strings: [
            "not respected",
            "some extent",
            "large extent",
            "fully respected",
            "I do not know"
        ]
    },
    23: {
        strings: [
            "not allowed",
            "do not enjoy",
            "some extent",
            "generally enjoy",
            "large extent",
            "virtually",
            "I do not know"
        ]
    },
    24: {
        strings: [
            "systematically",
            "occurs often",
            "some cases",
            "yes,",
            "I do not know"
        ]
    },
    25: {
        strings: [
            "constantly experience",
            "great",
            "large extent",
            "some",
            "do not experience",
            "I do not know"
        ]
    },
    26: {
        strings: [
            "actively prevented or shut down",
            "large extent",
            "some extent",
            "freely without",
            "I do not know"
        ]
    },
    27: {
        strings: [
            "actively prevented",
            "often prevented",
            "sometimes prevented",
            "can assemble freely",
            "I do not know"
        ]
    },
    28: {
        strings: [
            "entirely restricted",
            "large",
            "some extent",
            "complete freedom",
            "I do not know"
        ]
    },
    29: {
        strings: [
            "no information",
            "some information",
            "number of information",
            "large extent",
            "all information",
            "I do not know" 
        ]
    },
    30: {
        strings: [
            "regularly persecuted",
            "often persecuted",
            "occasion",
            "never persecuted",
            "I do not know",
            "Missing answer"
        ]
    },

    31: {
        strings: [
            "entirely censored",
            "large extent",
            "some extent",
            "not censored",
            "I do not know"
        ]
    },
    32: {
        strings: [
            "absolute",
            "occurs often",
            "occurs occasionally",
            "no media bias",
            "I do not know"
        ]
    },
    33: {
        strings: [
            "full extent",
            "large extent",
            "some extent",
            "not face",
            "I do not know"
        ]
    },
    34: {
        strings: [
            "fully limits",
            "large extent",
            "some extent",
            "there is no public",
            "I do not know"
        ]
    },
    35: {
        strings: [
            "always subject",
            "often subject",
            "regularly subject",
            "sometimes subject",
            "never subject",
            "I do not know"
        ]
    },

    36: {
        strings: [
            "always",
            "frequently",
            "often",
            "sometimes",
            "never",
            "i do not know"
        ]
    },
    37: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    38: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    39: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    40: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    41: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    42: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    43: {
        strings: [
            "Completely Agree",
            "Simply Agree",
            "Neutral",
            "Simply Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    44: {
        strings: [
            "commonly used",
            "often used",
            "some cases",
            "never used",
            "I do not know"
        ]
    },
    45: {
        strings: [
            "regularly restricted",
            "Several cases",
            "Some cases",
            "never restricted",
            "I do not know"
        ]
    },
    46: {
        strings: [
            "No,",
            "some",
            "large extent",
            "Yes,",
            "I do not know",
        ]
    },
    47: {
        strings: [
            "not protected", 
            "some measures",
            "large extent",
            "full extent",
            "I do not know"
        ]
    },
    48: {
        strings: [
            "non-existent",
            "some form",
            "large extent",
            "always protected",
            "I do not know"
        ]
    },

    49: {
        strings: [
            "not prevent or remedy",
            "some extent",
            "large extent",
            "Yes,",
            "I do not know"
        ]
    },
    50: {
        strings: [
            "does not protect",
            "some extent",
            "large extent",
            "fully protects",
            "I do not know"
        ]
    },
    51: {
        strings: [
            "regularly face",
            "often face",
            "sometimes face",
            "never faced",
            "I do not know"
        ]
    },
    52: {
        strings: [
            "No, the State does not apply",
            "different gender have completely different experiences",
            "large differences",
            "some differences",
            "applies to some extent",
            "large extent",
            "Yes, the State applies",
            "No, HRDs of a different gender have equal experiences",
            "I do not know"
        ]
    },
    53: {
        strings: [
            "does not protect",
            "No, the State does not address the situation",
            "No, the State differentiates",
            "The State addresses to some extent",
            "The State to some extent protects",
            "The State addresses to a large extent",
            "The State to a large extent protects",
            "Yes, the State addresses the situation",
            "Yes, the State protects",
            "I do not know"
        ]
    },


    55: {
        strings: [
            "Yes",
            "No"
        ]
    },
    56: {
        strings: [
            "Through work experience",
            "Through studies",
            "Personal Research",
            "Other"
        ]
    },
    57: {
        strings: [
            "woman",
            "male",
            "Prefer not to disclose",
        ]
    },   
    58: {
        strings: [
            "no separation of powers",
            "limited separation",
            "large extent",
            "full separation",
            "Not applicable"
        ]
    },

    59: {
        strings: [
            "No,",
            "some complaints",
            "Most complaints",
            "Yes,",
            "Not applicable",
            "Missing answer"
        ]
    },
    60: {
        strings: [
            "does not provide",
            "limited redress",
            "large extent",
            "provides for redress mechanisms for everyone",
            "Not applicable"
        ]
    },
    61: {
        strings: [
            "fully restricted",
            "large extent",
            "some extent",
            "no legal obstacles"
        ]
    },
    62: {
        strings: [
            "fully restrict",
            "large extent",
            "some extent",
            "No,",
            "Not applicable"
        ]
    },
    63: {
        strings: [
            "Yes, there is legislation that always labels",
            "Yes, there is legislation that results",
            "allows to a large extent",
            "Under some circumstances",
            "does not address",
            "does not frame",
            "Not applicable"
        ]
    },
    64: {
        strings: [
            "Yes,",
            "often requires",
            "sometimes requires",
            "Under some circumstances",
            "No,",
            "Not applicable"
        ]
    },

    65: {
        strings: [
            "Yes,",
            "large extent",
            "some extent",
            "No,",
            "Not applicable"
        ]
    },
    66: {
        strings: [
            "No,",
            "considerable amount of legal restrictions",
            "few legal",
            "Yes,",
            "Not applicable"
        ]
    },
    67: {
        strings: [
            "No,",
            "some extent",
            "There is some national legislation protecting",
            "a large extent",
            "Yes,"
        ]
    },
    68: {
        strings: [
            "Yes,",
            "large extent",
            "some extent",
            "No,",
            "Not applicable",
            "Missing answer"
        ]
    },
    69: {
        strings: [
            "Yes,",
            "large extent",
            "some extent",
            "No,",
            "Not applicable"
        ]
    },
    70: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    71: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    72: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    73: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    74: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },

    75: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    76: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    77: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    78: {
        strings: [
            "No,",
            "some extent",
            "large extent",
            "Yes,",
            "Not applicable"
        ]
    },
    79: {
        strings: [
            "no precise",
            "some vague",
            "sometimes information is still illegitimately classified as such",
            "bit vague",
            "very precise",
            "Not applicable."
        ]
    },
    80: {
        strings: [
            "Yes,",
            "large extent",
            "some",
            "No,",
            "applicable"
        ]
    },
    81: {
        strings: [
            "Yes",
            "often",
            "sometimes",
            "No,",
            "applicable."
        ]
    },
    82: {
        strings: [
            "Yes",
            "large extent",
            "some",
            "No,",
            "applicable"
        ]
    },
    83: {
        strings: [
            "No,",
            "There is no national",
            "some",
            "large extent",
            "Yes",
            "There is a full",
            "applicable"
        ]
    },
    84: {
        strings: [
            "No,",
            "large extent",
            "some",
            "Yes,",
            "applicable"
        ]
    },
    85: {
        strings: [
            "No,",
            "limited protection",
            "large extent",
            "Yes",
            "applicable."
        ]
    },
    86: {
        strings: [
            "No,",
            "some",
            "large extent",
            "Yes,",
            "applicable"
        ]
    },
    87: {
        strings: [
            "No,",
            "some",
            "large",
            "Yes",
            "applicable"
        ]
    },
    88: {
        strings: [
            "does not apply",
            "some",
            "large extent",
            "Yes",
            "applies equally to all people",
            "applicable"
        ]
    },
    89: {
        strings: [
            "No,",
            "some",
            "large extent",
            "Yes",
            "applicable"
        ]
    }
}

export default answerStrings